import { ChangeDetectionStrategy, Component, NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { OeAppService } from '../shared/oe-app.service';
import { OeAppPersonService } from '../shared/oe-app-person.service';
import { IFrameSizeEventType } from '../shared/types/iframe-event-type';
import { isIFrameSameOrigin } from '../shared/helpers/is-same-origin';
import { BehaviorSubject } from 'rxjs';
import { myCoachService } from '../home/my-coach-section/my-coach.service';
import { WindowService } from '../shared/window.service';
import { UserwaySyncModule } from '../shared/userway-sync.directive';

@Component({
  selector: 'lp2-my-coah-page',
  template: `
    <section *ngIf="myCoachFrameUrl$ | async as url; else loading" class="h-100 w-100">
      <iframe lp2UserwaySync class="border-0 w-100" [src]="url | safeUrl" [style.height.px]="height$ | async"> </iframe>
    </section>

    <ng-template #loading>
      <div style="height: 140px"></div>
      <div class="content d-flex align-items-center">
        <div class="loader"></div>
      </div>
    </ng-template>
  `,
  styles: [
    `
      :host {
        flex: 1;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyCoachPageComponent implements OnInit {
  public myCoachFrameUrl$ = new BehaviorSubject<string>(null);
  public height$ = new BehaviorSubject(1180);

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private coachService: myCoachService,
    private windowService: WindowService
  ) {
    this.handleEvents = this.handleEvents.bind(this);
  }

  ngOnInit() {
    this.coachService.hasCoachAccess$().subscribe((hasCoachAccess) => {
      if (hasCoachAccess) {
        this.myCoachFrameUrl$.next(
          `${this.oeApp.webMyCoachPageHost}` +
          `?env=${this.oeApp.environment}` +
          `&contactId=${this.oeAppPersonService.contactId}` +
          `&lang=${this.oeAppPersonService.preferredLang}` + 
          `&personId=${this.oeAppPersonService.id}`
        );

        window.addEventListener('message', this.handleEvents);
      } else if (hasCoachAccess === false) {
        this.windowService.redirectToUrl('/login.html');
      }
    });
  }

  private handleEvents({ data, origin }) {
    if (!isIFrameSameOrigin(this.oeApp.webMyCoachPageHost, origin)) {
      return;
    }
    const type: IFrameSizeEventType = data.type;
    switch (type) {
      case IFrameSizeEventType.HEIGHT:
        if (data.height) {
          this.height$.next(data.height);
        }
        break;
    }
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }
}

@NgModule({
  entryComponents: [MyCoachPageComponent],
  imports: [CommonModule, SafeUrlPipeModule, UserwaySyncModule],
  declarations: [MyCoachPageComponent],
})
export class MyCoachPageModule { }



// WEBPACK FOOTER //
// ./ts/app/my-coach/my-coach-page.component.ts